import * as actionTypes from "./actions";
import * as I from "immutable";

//todo: move to middleware
let savedFavoritesConfig = window.localStorage.getItem("takyon_favorites");
/*
const savedFavorites = savedFavoritesConfig
  ? JSON.parse(savedFavoritesConfig)
  : [{id: 'SPY', label: 'SPY'}, {id: 'ORCL', label: 'ORCL'}, {id: 'IONQ', label: 'IONQ'}, {id: 'FJET', label: 'FJET'}, {id: 'CRCL', label: 'CRCL'}, {id: 'ONDS', label: 'ONDS'}, {id: 'CRWV', label: 'CRWV'}, {id: 'LWLG', label: 'LWLG'}];
  */

const savedFavorites = [
 {id: 'CRWV', label: 'CRWV'},
 {id: 'CSIQ', label: 'CSIQ'},
 {id: 'FCEL', label: 'FCEL'},
 {id: 'IBRX', label: 'IBRX'},
 {id: 'IONQ', label: 'IONQ'},
 {id: 'IREN', label: 'IREN'},
 {id: 'NBIS', label: 'NBIS'},
 {id: 'NUAI', label: 'NUAI'},
 {id: 'POET', label: 'POET'},
 {id: 'TSEM', label: 'TSEM'},
 {id: 'IONQ', label: 'IONQ'},
 {id: 'WULF', label: 'WULF'},
 ];

let mmap = I.Map();
mmap = mmap.set(0, 'CRWV');
mmap = mmap.set(1, 'CSIQ');
mmap = mmap.set(2, 'FCEL');
mmap = mmap.set(3, 'IBRX');
mmap = mmap.set(4, 'IONQ');
mmap = mmap.set(5, 'IREN');
mmap = mmap.set(6, 'NBIS');
mmap = mmap.set(7, 'NUAI');
mmap = mmap.set(8, 'POET');
mmap = mmap.set(9, 'TSEM');
mmap = mmap.set(10, 'IONQ');
mmap = mmap.set(11, 'WULF');

const initialState = {
  favorites: savedFavorites,
  index: 0,
  count: 0,
  multiMap: mmap
};

const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.SET_MULTI_MAP_INDEX: {
      console.log("------------------ SET_MULTI_MAP_INDEX ---------------");
      console.log(action.payload);
      let count = state.count + 1;
      return {
        ...state,
        index: action.payload.index,
        count: count
      }
    }

    case actionTypes.SET_MULTI_MAP_VALUE: {
      console.log("------------------ SET_MULTI_MAP_VALUE ---------------");
      console.log(action.payload);
      let multiMap = state.multiMap;
      multiMap = multiMap.set(state.index, action.payload.value);
      console.log(multiMap);
      return {
        ...state,
        multiMap: multiMap
      }
    }

    case actionTypes.SET_FAVORITES: {
      console.log("SET_FAVORITES");
      console.log(action.payload);
      window.localStorage.setItem("takyon_favorites", JSON.stringify(action.payload));
      return {
        ...state,
        favorites: action.payload,
      };
    }

    case actionTypes.ADD_FAVORITES: {
      console.log("ADD_FAVORITES");
      console.log(action.payload);
      let items = state.favorites;
      items.push({ id: action.payload, label: action.payload });
      window.localStorage.setItem("takyon_favorites", JSON.stringify(items));

      return {
        ...state,
        favorites: items,
      };
    }

    case actionTypes.REMOVE_FAVORITES: {
      let items = state.favorites.filter(
        (item) => item.label !== action.payload
      );
      window.localStorage.setItem("takyon_favorites", JSON.stringify(items));

      return {
        ...state,
        favorites: items,
      };
    }

    default:
      return state;
  }
};

export default favoritesReducer;
